import { createFileRoute } from "@tanstack/react-router";
import heroNews from "@/assets/hero-news.jpg";

const NEWS_POSTS = [
  { title: "The Field Collection Drops", date: "Spring 2025", datePublished: "2025-03-01", excerpt: "Our most anticipated collection yet — built for the duck blind, dove field, and everywhere in between." },
  { title: "Coyote Creek x Local Outfitters", date: "Winter 2024", datePublished: "2024-12-01", excerpt: "We're partnering with select outfitters across Texas to bring our gear closer to the field." },
  { title: "Founded in Texas", date: "2023", datePublished: "2023-01-01", excerpt: "How a lifetime of hunting, fishing, and faith built the foundation for Coyote Creek Hat Co." },
];

export const Route = createFileRoute("/news")({
  head: () => ({
    meta: [
      { title: "News | Coyote Creek Hat Co." },
      { name: "description", content: "The latest news, drops, and stories from Coyote Creek Hat Co." },
      { property: "og:title", content: "News | Coyote Creek Hat Co." },
      { property: "og:description", content: "The latest news, drops, and stories from Coyote Creek Hat Co." },
      { property: "og:url", content: "https://coyotecreekhatco.com/news" },
    ],
    links: [{ rel: "canonical", href: "https://coyotecreekhatco.com/news" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Coyote Creek Hat Co. News",
          url: "https://coyotecreekhatco.com/news",
          blogPost: NEWS_POSTS.map((p) => ({
            "@type": "BlogPosting",
            headline: p.title,
            datePublished: p.datePublished,
            description: p.excerpt,
            author: { "@type": "Organization", name: "Coyote Creek Hat Co." },
          })),
        }),
      },
    ],
  }),
  component: NewsPage,
});

function NewsPage() {
  const posts = NEWS_POSTS;


  return (
    <div>
      <div className="relative w-full h-[50vh] min-h-[320px] overflow-hidden">
        <img src={heroNews} alt="Latest updates and brand stories from Coyote Creek Hat Co." className="absolute inset-0 h-full w-full object-cover" width={1920} height={768} />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="font-heading text-5xl md:text-7xl uppercase tracking-[0.15em] text-white text-center px-6 drop-shadow-lg">News</h1>
        </div>
      </div>

      <section className="py-20">
        <div className="mx-auto max-w-4xl px-6">
          <h2 className="font-heading text-3xl text-primary">Latest News</h2>
          <div className="mt-10 space-y-8">
            {posts.map(p => (
              <article key={p.title} className="rounded-xl border border-border bg-card p-8">
                <p className="font-ui text-xs uppercase tracking-widest text-muted-foreground">{p.date}</p>
                <h3 className="mt-2 font-heading text-2xl text-primary">{p.title}</h3>
                <p className="mt-3 text-muted-foreground">{p.excerpt}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
